








































import { Component, Prop, Vue } from "vue-property-decorator";

import PagePreview from "@/views/layoutEditor/pagePreview/pagePreview.vue";
// common componentsのPageControllerとは別
import PageController from "./pageController/pageController.vue";

import * as def from "@/definitions";

import { Document } from "@/model/document2/document";
import { Page } from "@/model/document2/page/page";

import { NewDesignCommand } from "@/commands/newDesignCommand";
import { DebugHelper } from "@/helper/debugHelper";

import AngleDown from "../resources/angleDown.vue";
import AngleUp from "../resources/angleUp.vue";

@Component({
  components: {
    PagePreview,
    PageController,

    AngleDown,
    AngleUp
  }
})
export default class SelectFrame extends Vue {
    @Prop()
    private opened!: boolean;

    public get currentDocument(): Document {
        return this.$store.getters.document;
    }

    public get currentPage(): Page {
        var document = this.currentDocument;
        return document.pageList[document.currentPageIndex];
    }

    public get currentPageNumber(): number {
        return this.currentDocument.currentPageIndex + 1;
    }

    // ページ数
    public get maxPage(): number {
        return this.currentDocument.pageList.length;
    }

    private get bleedSize() {
        return this.$store.getters.userConfig.bleedSize;
    }

    private get documentRotate()
    {
        return this.currentDocument.rotate;
    }

    // 表・裏
    private get hasReverse()
    {
        return this.currentDocument.hasReverseSurface;
    }


    private get isReverseSurface() 
    {
        var document = this.currentDocument;
        return document.isReverseSurface;
    }

    private changeSurface()
    {
        this.$emit("doCommand", "changeSurface", { isReverse: !this.currentDocument.isReverseSurface });
    }

    private selectDesign(direction : string)
    {
        // position を求める
        var position = this.currentPage.currentDesignPosition;
        var surface = this.currentPage.getSurface(this.isReverseSurface);
        if(direction == "left" || direction == "right")
        {
            var currentX = surface.getDesignRect(this.currentPage.currentDesignPosition).x;

            // 横方向のポジションを得る
            var horizontalPositions = this.currentDocument.getHorizontalPositionArray(this.currentPage.currentDesignPosition);
            if(direction == "left")
            {
                // 今のX位置より小さく、かつ一番大きなXの値を持つpositionを求める
                var maxX = -1;
                for(var i = 0; i < horizontalPositions.length; ++i)
                {
                    var pos = horizontalPositions[i];
                    var rect = surface.getDesignRect(pos);
                    if(rect.x < currentX && maxX < rect.x)
                    {
                        maxX = rect.x;
                        position = pos;
                    }
                }
            }
            else
            {
                // 今のX位置より大きく、かつ一番小さなXの値を持つpositionを求める
                var minX = 10000;
                for(var i = 0; i < horizontalPositions.length; ++i)
                {
                    var pos = horizontalPositions[i];
                    var rect = surface.getDesignRect(pos);
                    if(currentX < rect.x && rect.x < minX)
                    {
                        minX = rect.x;
                        position = pos;
                    }
                }
            }
        }
        else 
        {
            var currentY = surface.getDesignRect(this.currentPage.currentDesignPosition).y;

            // 縦方向のポジションを得る
            var verticalPositions = this.currentDocument.getVerticalPositionArray(this.currentPage.currentDesignPosition);
            if(direction == "top")
            {
                // 今のY位置より小さく、かつ一番大きなYの値を持つpositionを求める
                var maxY = -1;
                for(var i = 0; i < verticalPositions.length; ++i)
                {
                    var pos = verticalPositions[i];
                    var rect = surface.getDesignRect(pos);
                    if(rect.y < currentY && maxY < rect.y)
                    {
                        maxY = rect.y;
                        position = pos;
                    }
                }
            }
            else
            {
                // 今のY位置より大きく、かつ一番小きなYの値を持つpositionを求める
                var minY = 10000;
                for(var i = 0; i < verticalPositions.length; ++i)
                {
                    var pos = verticalPositions[i];
                    var rect = surface.getDesignRect(pos);
                    if(currentY < rect.y && rect.y < minY)
                    {
                        minY = rect.y;
                        position = pos;
                    }
                }
            }
        }

        DebugHelper.trace(position)

        if(position != this.currentPage.currentDesignPosition)
        {
            this.$emit("doCommand", "selectDesign", { position : position });
        }
    }

    private onDoCommand(command: string, paramater: any) {
        this.$emit("doCommand", command, paramater);
    }

    openAnimate = false;
    closeAnimate = false;
    private changeOpen() {
        this.$emit("changeOpen");
        this.$nextTick(() => {
            if (this.opened) {
                this.openAnimate = true;
                setTimeout(() => {
                    this.openAnimate = false;
                }, 250);
            } else {
                this.closeAnimate = true;
                setTimeout(() => {
                    this.closeAnimate = false;
                }, 200);
            }
        });
    }


    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigStyleColor(){
        var style = {
            backgroundColor : this.$store.getters.userConfigColors.buttonColorCode
        };
        return style;
    }

    private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }
}
